import { runWithRenderSlice } from "@otto-ec/global-resources/core";
import { on } from "svelte/events";
import { getAriaLabelFromInteractiveElement } from "./getAriaLabelFromInteractiveElement";
import { ensureId } from "./ensureId";
import { hintSlotName, errorSlotName } from "../slotNames";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useOcAuto = (
  Host: HTMLElement,
  actionElement: () => HTMLElement | undefined,
): void => {
  $effect(() => {
    const element = actionElement();
    if (!element) return;

    const setAriaLabel = (): void => {
      /*                                                                             */
      /*                                                                                    */
      if (
        element instanceof HTMLInputElement ||
        element instanceof HTMLButtonElement ||
        element instanceof HTMLSelectElement ||
        element instanceof HTMLTextAreaElement
      ) {
        const otherChildren = Array.from(Host.childNodes).filter((child) => {
          /*                                                                            */
          if (child instanceof Text) return child.textContent.trim().length! > 0;

          /*                                                                                     */
          if (child instanceof HTMLElement) {
            return child !== element && ![errorSlotName, hintSlotName].includes(child.slot);
          }

          /*                                                                             */
          return false;
        });

        /*                                                                                       */
        if (otherChildren.every((c) => c instanceof HTMLLabelElement)) {
          /*                                                                                    */
          const inputId = ensureId(element);
          otherChildren
            .filter((child): child is HTMLLabelElement => child instanceof HTMLLabelElement)
            .forEach((label) => (label.htmlFor = inputId));

          /*                                                                           */
          element.ariaLabel = null;
          return;
        }
      }

      /*                                                                                   */
      element.ariaLabel = getAriaLabelFromInteractiveElement(Host);
    };

    /*                                                                                */
    if (element.ariaLabel === "oc-auto") {
      /*                                                    */
      element.__ocAutoAriaLabel = true;
      runWithRenderSlice(setAriaLabel);
    }

    /*                                                                                  */
    /*                                   */
    if (!element.__ocAutoAriaLabel) return;

    /*                                                                              */
    /*                                                      */
    return on(element, "focusin", setAriaLabel);
  });
};
